<script setup lang="ts">
import MenuItem from 'components/widgets/conversation/contextMenu/menuItem.vue';

const props = defineProps({
  enabledOptions: {
    type: Object,
    default: () => ({}),
  },
});
const emit = defineEmits<{
  sendNow: [];
  changeSendTime: [];
  replyTo: [];
  copy: [];
  copyVideoNoteFileId: [];
  copyLink: [];
  translate: [];
  editMessage: [];
  cannedResponse: [];
  deleteMessage: [];
}>();
</script>

<template>
  <div class="menu-container">
    <MenuItem
      v-if="props.enabledOptions['sendNow']"
      :option="{
        icon: 'send',
        label: $t('CONVERSATION.CONTEXT_MENU.SEND_NOW'),
      }"
      variant="icon"
      @click.stop="emit('sendNow')"
    />
    <MenuItem
      v-if="props.enabledOptions['changeSendTime']"
      :option="{
        icon: 'calendar',
        label: $t('CONVERSATION.CONTEXT_MENU.CHANGE_SEND_TIME'),
      }"
      variant="icon"
      @click.stop="emit('changeSendTime')"
    />
    <MenuItem
      v-if="props.enabledOptions['replyTo']"
      :option="{
        icon: 'arrow-reply',
        label: $t('CONVERSATION.CONTEXT_MENU.REPLY_TO'),
      }"
      variant="icon"
      @click.stop="emit('replyTo')"
    />
    <MenuItem
      v-if="props.enabledOptions['copy']"
      :option="{
        icon: 'clipboard',
        label: $t('CONVERSATION.CONTEXT_MENU.COPY'),
      }"
      variant="icon"
      @click.stop="emit('copy')"
    />
    <MenuItem
      v-if="props.enabledOptions['translate']"
      :option="{
        icon: 'translate',
        label: $t('CONVERSATION.CONTEXT_MENU.TRANSLATE'),
      }"
      variant="icon"
      @click.stop="emit('translate')"
    />
    <MenuItem
      v-if="props.enabledOptions['copyVideoNoteFileId']"
      :option="{
        icon: 'clipboard',
        label: $t('CONVERSATION.CONTEXT_MENU.COPY_VIDEO_NOTE_FILE_ID'),
      }"
      variant="icon"
      @click.stop="emit('copyVideoNoteFileId')"
    />
    <MenuItem
      v-if="props.enabledOptions['edit']"
      :option="{
        icon: 'edit',
        label: $t('CONVERSATION.CONTEXT_MENU.EDIT'),
      }"
      variant="icon"
      @click.stop="emit('editMessage')"
    />
    <MenuItem
      v-if="props.enabledOptions['delete']"
      class="!text-red-600 dark:!text-red-500 hover:!bg-red-50 dark:hover:!bg-red-900/20"
      :option="{
        icon: 'delete',
        label: $t('CONVERSATION.CONTEXT_MENU.DELETE'),
      }"
      variant="icon"
      @click.stop="emit('deleteMessage')"
    />
    <hr />
    <MenuItem
      v-if="props.enabledOptions['copyLink']"
      :option="{
        icon: 'link',
        label: $t('CONVERSATION.CONTEXT_MENU.COPY_PERMALINK'),
      }"
      variant="icon"
      @click.stop="emit('copyLink')"
    />
    <MenuItem
      v-if="props.enabledOptions['cannedResponse']"
      :option="{
        icon: 'comment-add',
        label: $t('CONVERSATION.CONTEXT_MENU.CREATE_A_CANNED_RESPONSE'),
      }"
      variant="icon"
      @click.stop="emit('cannedResponse')"
    />
  </div>
</template>

<style scoped lang="scss">
.menu-container {
  @apply p-1 bg-white dark:bg-slate-900 shadow-xl rounded-md;

  hr:first-child {
    @apply hidden;
  }

  hr {
    @apply m-1 border-b border-solid border-n-strong;
  }
}
</style>
